import { getScriptRoot } from '.';
__webpack_public_path__ = `${getScriptRoot()}/`;
